export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/shared/utils/get-component-display-name.js